import React, { createContext } from 'react';

export const FlowParamsContext = createContext<{
  flowType?: string;
  resourceType?: 'source' | 'sink';
  id?: number;
  nexsetId?: number;
  sourceId?: number;
  isModal?: boolean;
  isEditMode?: boolean;
  onDismiss?: (data: any) => void;
  queryParams?: Record<string, any>;
}>({});

type FlowParamsProviderProps = {
  children: React.ReactNode;
  flowType?: string;
  resourceType?: 'source' | 'sink';
  id?: number;
  nexsetId?: number;
  sourceId?: number;
  isModal?: boolean;
  isEditMode?: boolean;
  onDismiss?: (data: any) => void;
  queryParams?: Record<string, any>;
};
export default function FlowParamsProvider({ children, ...rest }: FlowParamsProviderProps) {
  return <FlowParamsContext.Provider value={rest}>{children}</FlowParamsContext.Provider>;
}
